"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CenteredSpinner = exports.CenteredFadeInSpinner = void 0;
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var LayoutComponents_1 = require("../style/LayoutComponents");
var StyleFunctions_1 = require("../style/StyleFunctions");
var fadeInAnimation = StyleFunctions_1.keyframes({
    '0%': { opacity: 0 },
    '100%': { opacity: 1 }
});
var fadeInStyle = {
    animationName: fadeInAnimation,
    animationDuration: '2s',
    animationTimingFunction: 'ease-in',
};
var centeredStyle = {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};
var CenteredContainer = LayoutComponents_1.divWithStyle('CenteredContainer', centeredStyle);
var CenteredFadeInContainer = LayoutComponents_1.divWithStyle('CenteredFadeInContainer', [centeredStyle, fadeInStyle]);
function CenteredFadeInSpinner(props) {
    var _a;
    return (React.createElement(CenteredFadeInContainer, null,
        React.createElement(widgets_1.ActivitySpinnerWidget, { testId: (_a = props.testId) !== null && _a !== void 0 ? _a : '' })));
}
exports.CenteredFadeInSpinner = CenteredFadeInSpinner;
function CenteredSpinner(props) {
    var _a;
    return (React.createElement(CenteredContainer, null,
        React.createElement(widgets_1.ActivitySpinnerWidget, { testId: (_a = props.testId) !== null && _a !== void 0 ? _a : '' })));
}
exports.CenteredSpinner = CenteredSpinner;
//# sourceMappingURL=CenteredSpinner.js.map